export default {
  dashboard: {
    notes: 'Label of dashboard link in sidebar',
    message: 'Dashboard',
  },
  search: {
    notes: 'Label for navigation to parts search',
    message: 'Search parts',
  },
  catalogs: {
    notes: 'Label for navigation to parts catalogs (SPCs)',
    message: 'Spare parts catalogues',
  },
  recommendations: {
    notes: 'Label for Parts recommendations link',
    message: 'Parts recommendations',
  },
  shoppinglists: {
    notes: 'Label for shopping lists link',
    message: 'Shopping lists',
  },
  parts: {
    notes: 'Label of parts link in sidebar',
    message: 'Order parts & products',
  },
  order: {
    notes: 'Label of order link in sidebar',
    message: 'Order overview',
  },
  cart: {
    notes: 'Label of cart link in sidebar',
    message: 'Cart',
  },
};
